import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody
} from 'reactstrap';
import NotesPanel from '../../../../components/Notes/NotesPanel';

const NotesAction = ({ isOpen, toggle, deal }) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
      style={{ maxWidth: '900px' }}
    >
      <ModalHeader toggle={toggle}>
        <i className="ni  mr-2" />
        {deal?.legalName || 'Deal'} Notes
      </ModalHeader>
      <ModalBody style={{ padding: '0' }}>
        <NotesPanel
          tag="deal-notes"
          originType="DEAL"
          originId={deal?.privateId}
          onNoteAdded={(note) => console.log('Deal note added:', note)}
          onNoteUpdated={(noteId, updatedNote) => console.log('Deal note updated:', noteId, updatedNote)}
          onNoteDeleted={(noteId) => console.log('Deal note deleted:', noteId)}
        />
      </ModalBody>
    </Modal>
  );
};

export default NotesAction;

